import { render, staticRenderFns } from "./LeakDataTableCell.vue?vue&type=template&id=0bfbb93d&scoped=true"
import script from "./LeakDataTableCell.vue?vue&type=script&lang=js"
export * from "./LeakDataTableCell.vue?vue&type=script&lang=js"
import style0 from "./LeakDataTableCell.vue?vue&type=style&index=0&id=0bfbb93d&prod&scoped=true&lang=scss"
import style1 from "./LeakDataTableCell.vue?vue&type=style&index=1&id=0bfbb93d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfbb93d",
  null
  
)

export default component.exports